// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-card{background-color:var(--v-modalBackground-base)}.select-box{width:20px;height:20px;border:1px solid var(--v-accentBlue-base);background:#fff;border-radius:5px}.select-box i{height:100%}.select-box.selected{background:var(--v-accentBlue-base)}.accept-terms-button{display:block!important}", ""]);
// Exports
module.exports = exports;
